import { Typography } from "@mui/material";

const HmLoading = () => {
  return <Typography className="loading-data">Loading...</Typography>;
};

export default HmLoading;
